import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateOpportunityComponent } from './create-opportunity.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AccountSelectorModule } from '../../../accounts/account-selector/account-selector.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { SalesOrderConfirmationModule } from '../../../sales-orders/sales-order-confirmation/sales-order-confirmation.module';
import { OpportunityPipelineSelectorComponent } from './opportunity-pipeline-selector/opportunity-pipeline-selector.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { VaFormsModule } from '@vendasta/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TypeSelectorComponent } from '../../type-selector/type-selector.component';
import { CreateOpportunityService } from './create-opportunity.service';
import { ContractDurationSelectorModule } from '../opportunity-details/opportunity-info/opportunity-info-form/editable-fields/contract-duration-selector/contract-duration-selector.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    AccountSelectorModule,
    FormsModule,
    MatButtonModule,
    MatStepperModule,
    ReactiveFormsModule,
    SalesOrderConfirmationModule,
    GalaxyFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    MatInputModule,
    VaFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatDividerModule,
    TypeSelectorComponent,
    MatProgressSpinnerModule,
    ContractDurationSelectorModule,
  ],
  declarations: [CreateOpportunityComponent, OpportunityPipelineSelectorComponent],
  exports: [CreateOpportunityComponent],
  providers: [CreateOpportunityService],
})
export class CreateOpportunityModule {}
